import { render } from "./SharedFSTab.vue?vue&type=template&id=f3ea9c50&scoped=true"
import script from "./SharedFSTab.vue?vue&type=script&lang=js"
export * from "./SharedFSTab.vue?vue&type=script&lang=js"

import "./SharedFSTab.vue?vue&type=style&index=0&id=f3ea9c50&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3ea9c50"]])

export default __exports__